import { render, staticRenderFns } from "./PeriodRange.vue?vue&type=template&id=04e96614"
import script from "./PeriodRange.vue?vue&type=script&lang=js"
export * from "./PeriodRange.vue?vue&type=script&lang=js"
import style0 from "./PeriodRange.vue?vue&type=style&index=0&id=04e96614&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports